export default{
    
    sellerParam:{
incoming_seller:null,
outgoing_seller:null,
},
sellers:[]

}


// WEBPACK FOOTER //
// ./src/modules/reassign_seller/state.js